import {DrawerProps} from '@mantine/core';
import {useParams} from "react-router-dom";
import {FormDrawer} from "./FormDrawer.tsx";
import {usePipeline} from "../hooks/usePipeline.ts";


export const EditFormDrawer = (props: DrawerProps) => {

    const {id: pipelineId} = useParams();

    if (typeof pipelineId === 'undefined') {
        throw new Error('pipelineId is required parameter');
    }

    const {
        record,
        updateRecord,
    } = usePipeline(pipelineId);

    if (!record) return null;

    return (
        <FormDrawer
            record={record}
            handleSubmit={updateRecord}
            {...props}
        />
    )
};
